import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import AgentDashboard from "./pages/AgentDashboard";
import ClientDetail from "./pages/ClientDetail";
import LenderDashboard from "./pages/LenderDashboard";
import { InstallBanner } from "./components/InstallPrompt";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Navigate to="/login" replace />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute role="agent">
                  <AgentDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/client/:id"
              element={
                <ProtectedRoute role="agent">
                  <ClientDetail />
                </ProtectedRoute>
              }
            />
            <Route
              path="/lender"
              element={
                <ProtectedRoute role="admin">
                  <LenderDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/lender/client/:id"
              element={
                <ProtectedRoute role="admin">
                  <ClientDetail />
                </ProtectedRoute>
              }
            />
            <Route path="*" element={<Navigate to="/login" replace />} />
          </Routes>
          <InstallBanner />
        </BrowserRouter>
        <Toaster position="bottom-center" theme="dark" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
